import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TransferPricingOnboardingInformation } from './types';

export function useTransferPricingOnboarding(serviceProviderEntityId: number) {
  const URL = serviceProviderEntityId
    ? `transfer-pricing/onboarding?entityId=${serviceProviderEntityId}`
    : null;

  const {
    data: rawData,
    error,
    mutate,
  }: {
    data?: { onboardings: TransferPricingOnboardingInformation[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  // Extract first onboarding to maintain backward compatibility
  const data = rawData?.onboardings?.[0];

  return {
    data,
    error,
    mutate,
  };
}
